import { render } from "./StudentAttendance.vue?vue&type=template&id=29518734"
import script from "./StudentAttendance.vue?vue&type=script&lang=js"
export * from "./StudentAttendance.vue?vue&type=script&lang=js"

import "./StudentAttendance.vue?vue&type=style&index=0&id=29518734&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__